// extracted by mini-css-extract-plugin
module.exports = {"teamSection":"index-module--teamSection--2npgp","carouselWrapper":"index-module--carouselWrapper--_-nOp","carouselCard":"index-module--carouselCard--3Lt4Y"};